export default function getRecentSearches() {
  try {
    return JSON.parse(window.localStorage.getItem("cc:search")) || [];
  } catch (e) {
    return [];
  }
}
